module.exports = __webpack_public_path__ + "prod/1.42.2/media/online-education.110eb1df.mp4";